import React from 'react'

/**
 * Read-only pipe-set status: IWM Root CW↔CCW swapped in WPS/PQR reports.
 * Shown on Floor Sheet when meta.swapIwmBugType is true. Configure on Weld Parameters.
 */
export default function FloorSheetIwmRootSwapBanner({ enabled }: { enabled: boolean }) {
  if (!enabled) return null

  return (
    <div
      role="status"
      data-testid="floorsheet-iwm-root-swap-banner"
      title="Root CW↔CCW are swapped in WPS and PQR reports. Saved weld data is unchanged. Configure on Weld Parameters."
      className="rounded-lg border border-primary-200 bg-primary-50 px-4 py-2.5 text-sm text-primary-800"
    >
      <span className="font-semibold">IWM Root swapped in WPS/PQR</span>
      <span className="ml-1.5 text-primary-700">
        — Root CW↔CCW remapped in reports only. Edit on Weld Parameters.
      </span>
    </div>
  )
}
